<template>
  <ul class="item_main">
    <li>
      <span>异动文号:</span>
      <p>{{ info.ydwh ? info.ydwh : "-" }}</p>
    </li>
    <li>
      <span>异动日期:</span>
      <p>{{ info.ydrq ? info.ydrq : "-" }}</p>
    </li>
    <li>
      <span>生效学期:</span>
      <p>{{ info.sqsxrq ? info.sqsxrq : "-" }}</p>
    </li>
    <li>
      <span>学&emsp;&emsp;制:</span>
      <p>{{ info.sqxz ? info.sqxz : "-" }}</p>
    </li>
    <li>
      <span>所在年级:</span>
      <p>{{ info.sqdqszj ? info.sqdqszj : "-" }}</p>
    </li>
    <li>
      <span>院系名称:</span>
      <p>{{ info.sqyxmc ? info.sqyxmc : "-" }}</p>
    </li>
    <li>
      <span>专业名称:</span>
      <p>{{ info.sqzymc ? info.sqzymc : "-" }}</p>
    </li>
    <li>
      <span>班级名称:</span>
      <p>{{ info.bj ? info.bj : "-" }}</p>
    </li>
    <li>
      <span>培养层次:</span>
      <p>{{ info.sqppccmc ? info.sqppccmc : "-" }}</p>
    </li>
    <li>
      <span>毕业专业:</span>
      <p>{{ info.byzy ? info.byzy : "-" }}</p>
    </li>
    <li>
      <span>异动去向:</span>
      <p>{{ info.sqydqx ? info.sqydqx : "-" }}</p>
    </li>
    <li>
      <span>异动理由:</span>
      <p>{{ info.sqly ? info.sqly : "-" }}</p>
    </li>
    <li>
      <span>附件要求说明:</span>
      <p>{{ info.fjsm ? info.fjsm : "-" }}</p>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/newPages/student/xjydsq/mode/modeYdhqk.vue